import { AiApplyType } from "@/enum/list.enum";

import { PaginationMeta } from "@/types/types";

import { List } from "../schema/list";
import { Tracker } from "../../ProfileTracker/schema/profileTracker";

export const getCurrentPrices = ({
	applyTo,
	meta,
	singlePrice,
	selectedProspectIds,
	list,
	tracker,
}: {
	applyTo: AiApplyType;
	meta: PaginationMeta;
	singlePrice: number;
	selectedProspectIds?: number[];
	list?: List;
	tracker?: Tracker;
}) => {
	let credits = 0;

	if (applyTo === AiApplyType.FIRST_10) {
		credits = meta.itemCount > 10 ? 10 : meta.itemCount;
	}

	if (applyTo === AiApplyType.CURRENTLY_SELECTED) {
		credits = selectedProspectIds?.length || 0;
	}

	if (applyTo === AiApplyType.CURRENTLY_FILTERED) {
		credits = meta.itemCount;
	}

	if (applyTo === AiApplyType.ALL) {
		credits = list?.draftCount || tracker?.organizationCount || 0;
	}

	return credits * singlePrice;
};
